import React, { useState } from 'react';

export default function ChoiceCard({ data, onRespond }) {
  const [selected, setSelected] = useState(data.allowMultiple ? [] : null);

  const handleSelect = (option) => {
    if (data.answered) return;

    if (data.allowMultiple) {
      setSelected((prev) =>
        prev.includes(option.id)
          ? prev.filter((id) => id !== option.id)
          : [...prev, option.id]
      );
    } else {
      // Single select: respond immediately with the label text
      setSelected(option.id);
      onRespond(data.id, option.label);
    }
  };

  const handleConfirm = () => {
    if (selected.length > 0) {
      // Look up labels for all selected options
      const labels = data.options
        .filter((opt) => selected.includes(opt.id))
        .map((opt) => opt.label);
      onRespond(data.id, labels.join(', '));
    }
  };

  const isSelected = (optionId) => {
    if (data.allowMultiple) {
      return selected.includes(optionId);
    }
    return selected === optionId;
  };

  return (
    <>
      {data.title && <div className="ws-card__title">{data.title}</div>}

      <div className="ws-card-choices">
        {data.options?.map((option) => (
          <button
            key={option.id}
            className={`ws-card-choice ${isSelected(option.id) ? 'ws-card-choice--selected' : ''}`}
            onClick={() => handleSelect(option)}
            type="button"
          >
            {option.icon && (
              <span className="material-icons ws-card-choice__icon" aria-hidden="true">{option.icon}</span>
            )}
            <div>
              <div className="ws-card-choice__label">{option.label}</div>
              {option.description && (
                <div className="ws-card-choice__desc">{option.description}</div>
              )}
            </div>
          </button>
        ))}
      </div>

      {data.allowMultiple && !data.answered && (
        <div className="ws-card-actions">
          <button
            className="ws-card-btn ws-card-btn--primary"
            onClick={handleConfirm}
            disabled={selected.length === 0}
            type="button"
          >
            Bevestig
          </button>
        </div>
      )}
    </>
  );
}
